import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const webApiUrl = `${process.env.REACT_APP_BASE_URL}ospl_leq/`;
const tokenStr = process.env.REACT_APP_API_TOKEN;

// Async thunks for fetching data
export const fetchLeqHourly = createAsyncThunk("leq/fetchLeqHourly", () => {
  return axios
    .get(`${webApiUrl}?granularity=1`, {
      headers: { Authorization: `Token ${tokenStr}` },
    })
    .then((response) => response.data);
});

export const fetchLeqDaily = createAsyncThunk("leq/fetchLeqDaily", () => {
  return axios
    .get(`${webApiUrl}?granularity=2`, {
      headers: { Authorization: `Token ${tokenStr}` },
    })
    .then((response) => response.data);
});

export const fetchLeqNighttime = createAsyncThunk(
  "leq/fetchLeqNighttime",
  () => {
    return axios
      .get(`${webApiUrl}?granularity=23`, {
        headers: { Authorization: `Token ${tokenStr}` },
      })
      .then((response) => response.data);
  }
);

export const fetchLeqDaytime = createAsyncThunk("leq/fetchLeqDaytime", () => {
  return axios
    .get(`${webApiUrl}?granularity=7`, {
      headers: { Authorization: `Token ${tokenStr}` },
    })
    .then((response) => response.data);
});

// Initial state setup as an object for clearer state management
const initialState = {
  leqHourly: {
    loading: true,
    data: null,
    error: "",
  },
  leqNighttime: {
    loading: true,
    data: null,
    error: "",
  },
  leqDaytime: {
    loading: true,
    data: null,
    error: "",
  },
  leqDaily: {
    loading: true,
    data: null,
    error: "",
  },
};

// Redux slice
const leqSlice = createSlice({
  name: "leq",
  initialState,
  reducers: {}, // no additional reducers needed if everything is async
  extraReducers: (builder) => {
    // Handle fetchLeqHourly cases
    builder
      .addCase(fetchLeqHourly.pending, (state) => {
        state.leqHourly.loading = true;
      })
      .addCase(fetchLeqHourly.fulfilled, (state, action) => {
        state.leqHourly.loading = false;
        state.leqHourly.data = action.payload;
        state.leqHourly.error = "";
      })
      .addCase(fetchLeqHourly.rejected, (state, action) => {
        state.leqHourly.loading = false;
        state.leqHourly.data = [];
        state.leqHourly.error = action.error.message;
      });

    // Handle fetchLeqNighttime cases
    builder
      .addCase(fetchLeqNighttime.pending, (state) => {
        state.leqNighttime.loading = true;
      })
      .addCase(fetchLeqNighttime.fulfilled, (state, action) => {
        state.leqNighttime.loading = false;
        state.leqNighttime.data = action.payload;
        state.leqNighttime.error = "";
      })
      .addCase(fetchLeqNighttime.rejected, (state, action) => {
        state.leqNighttime.loading = false;
        state.leqNighttime.data = [];
        state.leqNighttime.error = action.error.message;
      });

    // Handle fetchLeqDaytime cases
    builder
      .addCase(fetchLeqDaytime.pending, (state) => {
        state.leqDaytime.loading = true;
      })
      .addCase(fetchLeqDaytime.fulfilled, (state, action) => {
        state.leqDaytime.loading = false;
        state.leqDaytime.data = action.payload;
        state.leqDaytime.error = "";
      })
      .addCase(fetchLeqDaytime.rejected, (state, action) => {
        state.leqDaytime.loading = false;
        state.leqDaytime.data = [];
        state.leqDaytime.error = action.error.message;
      });

    // Handle fetchLeqDaily cases
    builder
      .addCase(fetchLeqDaily.pending, (state) => {
        state.leqDaily.loading = true;
      })
      .addCase(fetchLeqDaily.fulfilled, (state, action) => {
        state.leqDaily.loading = false;
        state.leqDaily.data = action.payload;
        state.leqDaily.error = "";
      })
      .addCase(fetchLeqDaily.rejected, (state, action) => {
        state.leqDaily.loading = false;
        state.leqDaily.data = [];
        state.leqDaily.error = action.error.message;
      });
  },
});

export default leqSlice.reducer;
